import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "services",
  id: "services"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "container" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "carousel" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "carousel__items" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "carousel__items__item" }, [
        /*#__PURE__*/_createElementVNode("h3", null, "BOBINADOS DE MOTORES"),
        /*#__PURE__*/_createElementVNode("p", null, "Tenemos la experiencia y el equipo necesarios para reacondicionar motores de diferentes tipos y tamaños. Nuestro proceso de bobinado incluye una serie de pasos para garantizar que el motor quede en perfecto estado. Si necesita un servicio de bobinado de motores, no dude en ponerse en contacto con nosotros.")
      ])
    ])
  ])
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
}